import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';

import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

import './Squads.css';
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, ItemPicker, EmptyState, LoadingState } from './Common';
import Avatar from './Avatar'
import { SplitPane } from './Teams'
import { AddTeamWithSquads } from '.././pages/CreatePages/ClubInit'
import Positions from './Positions';
import { ChildBasicInforamation } from '../pages/Dashboard';

export const playerLimit = {
    soccer: 26,
    rugby: 39,
    cricket: 20
};

export default class Squads extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "Current Squad",
            currentFilter: "",
            yearFilter: "",
            player: null,
            userTabs: ["Current Squad", "Past Squad"],
            isAddingCurrentTeams: false,
            isManagingCurrent: false,
            isAddingPastTeams: false,
            isManagingPast: false,
            isInvitingTeams: false,
            isAddingPlayer: false,
            isViewPlayer: false
        }
    }

    getSquadNames = () => {
        const { past, current } = this.props.squads
        const list = [];
        current.forEach((item, i) => {
            list.push(item.name)
        });

        return list;
    }

    getSquadID = () => {
        const { past, current } = this.props.squads
        const squads = this.getSquadNames();
        const name = (this.state.currentFilter === "") ? squads[0] : this.state.currentFilter
        let index = current.findIndex((item) => item.name == name);

        return {
            id: (!current[index]) ? 0 : current[index].id,
            gender: (!current[index]) ? "male" : current[index].gender,
            name: (!current[index]) ? "" : current[index].name
        };
    }

    getYears = () => {
        const list = [];
        const d = new Date();
        for (let x = d.getFullYear(); x >= (d.getFullYear() - 5); x--) {
            if (x === (d.getFullYear() - 5)) {
                list.push(x + " and before")
            } else {
                list.push(x)
            }
        }

        return list;
    }

    render() {
        const squads = this.getSquadNames()
        const years = this.getYears()
        const { past, current } = this.props.squads
        const { isAddingPlayer, player } = this.state
        const currentSquad = this.getSquadID()
        return (
            <div className="default-view" style={{ backgroundColor: "#fff", marginTop: "10px", paddingBottom: "20px" }}>
                <div className="view-with-tabs">
                    {!this.props.isDashboard &&
                        <div className="view-with-tabs-head">
                            {
                                this.state.userTabs.map((item, i) => {
                                    return (
                                        <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ activeTab: item })}>{item}</div>
                                    )
                                })
                            }
                        </div>
                    }
                    <div className="view-with-tabs-body">
                        {(this.props.isAdmin && this.state.activeTab === "$Past Squad") &&
                            <div className="my-sports-list-head">
                                {past.length > 0 &&
                                    <div className="my-sports-list-head-item manage_photos" onClick={() => {
                                        this.setState({ isManagingPast: true })
                                    }}>
                                        <span>Manage {"Players"}</span>
                                    </div>
                                }
                            </div>
                        }

                        {(this.props.isAdmin && this.state.activeTab === "Current Squad" && !this.state.isViewPlayer) &&
                            <div className="my-sports-list-head">
                                <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isAddingPlayer: true })}>
                                    <span>Add Players</span>
                                </div>
                                <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isAddingCurrentTeams: true })}>
                                    <span>Add Squad</span>
                                </div>

                                {current.length > 0 && this.is &&
                                    <div className="my-sports-list-head-item manage_photos" onClick={() => {
                                        this.setState({ isManagingCurrent: true })
                                    }}>
                                        <span>Manage {"Players"}</span>
                                    </div>
                                }
                            </div>
                        }
                        {(this.props.isAdmin && this.state.activeTab === "Current Squad" && this.state.isViewPlayer) &&
                            <div className="my-sports-list-head">
                                <div className="my-sports-list-head-item" onClick={() => this.setState({ isAddingCurrentTeams: true })}>
                                    <span>Remove Player</span>
                                </div>

                                {current.length > 0 && this.is &&
                                    <div className="my-sports-list-head-item" onClick={() => {
                                        this.setState({ isManagingCurrent: true })
                                    }}>
                                        <span>Edit {"Player"}</span>
                                    </div>
                                }
                            </div>
                        }
                        {(this.state.activeTab === "Current Squad") &&
                            <SplitPane isViewMode={this.state.isViewPlayer} isExtended="true" active={(this.state.currentFilter === "") ? squads[0] : this.state.currentFilter} items={squads} setView={(d) => {
                                this.setState({
                                    currentFilter: d
                                });
                            }}>
                                <PlayerList onSetViewExpand={(val, player) => {
                                    this.setState({ isViewPlayer: val, player: player });
                                }} isCurrent={true} filter={(this.state.currentFilter === "") ? squads[0] : this.state.currentFilter} squads={current} keyFilter={"sport"} />
                            </SplitPane>
                        }
                        {(this.state.activeTab === "Past Squad") &&
                            <SplitPane isExtended="true" active={(this.state.yearFilter === "") ? years[0] : this.state.yearFilter} items={years} setView={(d) => {
                                this.setState({
                                    yearFilter: d
                                });
                            }}>

                            </SplitPane>
                        }
                    </div>
                </div>

                {isAddingPlayer &&
                    <AddPlayer jerseyArray={[]} sport={this.props.content.sport.name} isOpen={isAddingPlayer} teamId={this.props.contentId} squadId={currentSquad.id} gender={currentSquad.gender} name={currentSquad.name} onClose={(player) => this.setState({ isAddingPlayer: false })} />
                }
            </div>
        );
    }
}

class PlayerList extends Component {
    state = {
        isViewPlayer: false,
        isLoadingPlayer: false,
        user: null
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getPlayers = (val) => {
        if (this.props.isCurrent) {
            let squad = { players: [] };
            for (let x = 0; x < this.props.squads.length; x++) {
                const item = this.props.squads[x];
                if (item.name === val) {
                    squad = item
                    break;
                }
            }

            return FakeData.listify(squad.players);
        } else {
            if (val.toString().indexOf("before") > -1) {
                let value = val.split(" ");
                value = value[0];
                const list = []
                this.props.squads.forEach((item, i) => {
                    if (item.year <= val) {
                        list.push(item)
                    }
                })

                return list
            } else {
                const list = []
                this.props.squads.forEach((item, i) => {
                    if (item.year == val) {
                        list.push(item)
                    }
                })

                return list
            }
        }
    }

    getProfile = (child) => {
        const _that = this;
        if (!this._isMounted) {
            return
        }
        FakeData.post("/getUserProfile.php?auth0&id=" + FakeData.getData("yoo").id + "&them=" + child.userId, {}, {
            success: ((res) => {
                if (!_that._isMounted) {
                    return
                }

                if (res.error && _that._isMounted) {
                    _that.setState({
                        isLoadingPlayer: false
                    });
                } else if (_that._isMounted) {
                    _that.setState({
                        user: res,
                        isLoadingPlayer: false
                    });
                }
            }),
            error: ((err) => {
                _that.setState({
                    isLoadingPlayer: false
                });
            })
        })
    }

    render() {
        const players = this.getPlayers(this.props.filter);
        const { onSetViewExpand } = this.props;
        const { isLoadingPlayer, isViewPlayer, user } = this.state;

        return (
            <div className="club-team-list">
                {!isViewPlayer &&
                    players.map((item, i) => {
                        return (
                            <PlayerItem onClick={(player) => {
                                this.setState({
                                    isLoadingPlayer: true,
                                    isViewPlayer: true
                                });

                                if (onSetViewExpand) {
                                    onSetViewExpand(true, player)
                                }

                                this.getProfile(player)
                            }} key={i} isPast={false} item={item} canManage={this.props.canManage} />
                        )
                    })
                }
                {players.length === 0 && !isViewPlayer &&
                    <EmptyState isShown={true} icon={"person"} text="No players found!" style={{ height: "300px" }} />
                }
                {isViewPlayer && isLoadingPlayer &&
                    <LoadingState isShown={true} icon={"person"} text="Loading player info..." style={{ height: "300px" }} />
                }
                {isViewPlayer && !isLoadingPlayer && user !== null &&
                    <div style={{
                        width: "100%"
                    }}>
                        <div style={{
                            lineHeight: "40px",
                            borderBottom: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <i className="material-icons" style={{
                                color: "inherit",
                                fontSize: "inherit",
                                margin: "0px 10px 0px 5px"
                            }} onClick={() => {
                                this.setState({
                                    isLoadingPlayer: false,
                                    isViewPlayer: false,
                                    user: null
                                });

                                if (onSetViewExpand) {
                                    onSetViewExpand(false, null)
                                }
                            }}>arrow_back</i>
                            <span onClick={() => {
                                this.setState({
                                    isLoadingPlayer: false,
                                    isViewPlayer: false,
                                    user: null
                                });

                                if (onSetViewExpand) {
                                    onSetViewExpand(false)
                                }
                            }}>Back</span>
                            {this.props.canManage &&
                                <div style={{
                                    lineHeight: "40px",
                                    flex: 1,
                                    borderBottom: "1px solid #ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: 'row-reverse',
                                    borderBottom: "none"
                                }}>
                                    <span style={{
                                        marginRight: "10px",
                                        cursor: "pointer"
                                    }} onClick={() => {

                                    }}>Unsign</span>
                                    <span style={{
                                        marginRight: "10px",
                                        cursor: "pointer"
                                    }} onClick={() => {

                                    }}>Edit</span>
                                </div>
                            }
                        </div>
                        <ChildBasicInforamation profile={user} isAdmin={false} isParent={false} />
                    </div>
                }
                {isViewPlayer && !isLoadingPlayer && user === null &&
                    <div style={{
                        width: "100%"
                    }}>
                        <div style={{
                            lineHeight: "40px",
                            borderBottom: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <i className="material-icons" style={{
                                color: "inherit",
                                fontSize: "inherit",
                                margin: "0px 10px 0px 5px"
                            }} onClick={() => {
                                this.setState({
                                    isLoadingPlayer: false,
                                    isViewPlayer: false,
                                    user: null
                                });

                                if (onSetViewExpand) {
                                    onSetViewExpand(false)
                                }
                            }}>arrow_back</i>
                            <span onClick={() => {
                                this.setState({
                                    isLoadingPlayer: false,
                                    isViewPlayer: false,
                                    user: null
                                });

                                if (onSetViewExpand) {
                                    onSetViewExpand(false)
                                }
                            }}>Back</span>
                        </div>
                        <EmptyState isShown={true} icon={"person"} text="No information found!" style={{ height: "300px" }} />
                    </div>
                }
            </div>
        );
    }
}

class PlayerItem extends Component {
    state = {}
    render() {
        return (
            <div className={(this.props.isPast) ? "club-item past" : "club-item"}>
                <div className="club-item-header">
                    <img src={this.props.item.image} />
                    <div className="club-item-header-info">
                        <h2>{this.props.item.number}</h2>
                        <h2>{this.props.item.name}</h2>
                        <span>{this.props.item.position}</span>
                        <span>{this.props.item.origin}</span>
                    </div>
                </div>
                <div className="club-item-body">
                    <div className="club-item-body-info">
                        <div><span>Games</span><span>{this.props.item.games}</span></div>
                        <div><span>Goals</span><span>{this.props.item.goals}</span></div>
                    </div>
                    <a onClick={(e) => {
                        e.preventDefault();
                        this.props.onClick(this.props.item)
                    }}>View Player</a>
                </div>
            </div>
        )
    }
}

export class AddPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            image: { id: null, url: "" },
            token: "new",
            player: {
                name: "",
                email: "",
                position: "",
                origin: "",
                number: "",
                image: "",
                gender: "",
                height: "",
                age: "",
                games: 0,
                goals: 0
            },
            error: {
                user: false,
                name: false,
                position: false,
                number: false,
                origin: false,
                email: false,
                gender: false
            },
            user: { id: null, name: "" },
            isSearching: true
        }
    }

    save() {
        const { player, isSearching, user, error } = this.state
        if (player.name === "" || error.name) {
            error.name = true;
            this.setState({ error });
            return;
        }

        if (player.email === "" || error.email) {
            error.email = true;
            this.setState({ error });
            return;
        }

        if ((this.props.gender === "mixed") && (player.gender === "" || error.gender)) {
            error.gender = true;
            this.setState({ error });
            return;
        }

        if (player.position === "" || error.position) {
            error.position = true;
            this.setState({ error });
            return;
        }

        if (player.number === "" || error.number) {
            error.number = true;
            this.setState({ error });
            return;
        }

        if (player.origin === "" || error.origin) {
            error.origin = true;
            this.setState({ error });
            return;
        }

        const _that = this;
        const dataTo = {
            teamId: this.props.teamId,
            squadId: this.props.squadId,
            player,
            gender: (this.props.gender === "mixed") ? player.gender : this.props.gender
        }

        FakeData.post("/registerSquadPlayer.php?auth0", dataTo, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Could not add player to the team, check player email address and try again!");
                    if (res.isEmailError) {
                        error.email = true
                        _that.setState({ error });
                    }
                } else {
                    _that.props.onClose(res)
                }
            },
            error(err) {

            }
        }, true, "", (s) => { })
    }

    invite() {
        const { user, error } = this.state
        if (user.id === null || error.user) {
            error.user = true;
            this.setState({ error });
            return;
        }

        const _that = this;
        const dataTo = {
            userFrom: FakeData.getData("yoo").id,
            teamId: this.props.teamId,
            squadId: this.props.squadId,
            userTo: user.id,
            note: ""
        }

        FakeData.post("/createTeamInvite.php?auth0", dataTo, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Could not add player to the team, please check your network and try again!");
                } else {
                    FakeData.alert("Team invite was sent to " + user.name + "!");
                    error.user = false
                    _that.setState({ error, user: { id: null, name: "" }, token: Date.now() });
                }
            },
            error(err) {

            }
        }, true, "", (s) => { })

    }

    render() {
        const { player, isSearching, user, error, token } = this.state
        const positions = Positions[this.props.sport];
        const { jerseyArray, gender } = this.props
        const genderRequired = (gender === "mixed") ? true : false;
        return (
            <Modal isOpen={this.props.isOpen} onClose={() => this.props.onClose(null)}>
                <div className="add-place" style={{ width: "400px" }}>
                    <h1>Add player to {this.props.name} squad</h1>
                    <h4 style={{ cursor: "pointer", color: (isSearching) ? "#aaa" : "#CCC", paddingBottom: "5px", borderBottom: "none", position: "relative" }} onClick={() => this.setState({ isSearching: (isSearching) ? false : true })}>
                        Search Player
                            <i className="material-icons" style={{ fontSize: "14px", position: "absolute", right: 0, marginTop: "10px", marginRight: "10px" }}>{(isSearching) ? "add" : "remove"}</i>
                    </h4>
                    {isSearching &&
                        <div style={{ width: "100%" }}>
                            <ItemPicker key={token} label={"Name"} value={user.name} user={FakeData.getData("yoo")} error={error.user} onSelectedItem={(user) => {
                                user = user;
                                error.user = false;
                                this.setState({ user, error });
                            }} width="27.85em" isExtended={true} data={FakeData.getData("yoo").friends} />
                            <button style={{ lineHeight: "30px" }} onClick={this.invite.bind(this)}>Invite {user.name}</button>
                        </div>
                    }
                    <hr />
                    <h4 style={{ cursor: "pointer", color: (!isSearching) ? "#aaa" : "#CCC", paddingBottom: "5px", borderBottom: "none", position: "relative" }} onClick={() => this.setState({ isSearching: (isSearching) ? false : true })}>
                        Add New Player
                            <i className="material-icons" style={{ fontSize: "14px", position: "absolute", right: 0, marginTop: "10px", marginRight: "10px" }}>{(!isSearching) ? "add" : "remove"}</i>
                    </h4>
                    {!isSearching &&
                        <div style={{ width: "100%" }}>
                            <div className="input-field">
                                <span>Name</span>
                                <input className={(error.name) ? "normal-input error" : "normal-input"} style={{ border: "0.3px solid #aaa!important" }}
                                    value={player.name}
                                    onChange={(e) => {
                                        player.name = e.target.value;
                                        error.name = false
                                        this.setState({ player, error });
                                    }} />
                            </div>
                            <div className="input-field">
                                <span>Email</span>
                                <input className={(error.email) ? "normal-input error" : "normal-input"} style={{ border: "0.3px solid #aaa!important" }}
                                    value={player.email}
                                    onChange={(e) => {
                                        player.email = e.target.value;
                                        error.email = !FakeData.isEmail(e.target.value)
                                        this.setState({ player, error });
                                    }} />
                            </div>
                            {genderRequired &&
                                <div className="input-field">
                                    <span>Gender</span>
                                    <select className={(error.gender) ? "normal-input error" : "normal-input"} style={{ border: "0.3px solid #aaa!important" }}
                                        value={player.gender}
                                        onChange={(e) => {
                                            player.gender = e.target.value;
                                            error.gender = false
                                            this.setState({ player, error });
                                        }} >
                                        <option value="">Select position</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            }
                            <div className="input-field">
                                <span>Position</span>
                                <select className={(error.position) ? "normal-input error" : "normal-input"} style={{ border: "0.3px solid #aaa!important" }}
                                    value={player.position}
                                    onChange={(e) => {
                                        player.position = e.target.value;
                                        error.position = false
                                        this.setState({ player, error });
                                    }} >
                                    <option value="">Select position</option>
                                    {
                                        FakeData.listify(positions).map((item, i) => {
                                            return (<option key={i} value={item}>{item}</option>)
                                        })
                                    }
                                </select>
                            </div>
                            <div className="input-field">
                                <span>Jersey</span>
                                <input className={(error.number) ? "normal-input error" : "normal-input"} style={{ border: "0.3px solid #aaa!important" }}
                                    value={player.number}
                                    type="number"
                                    min={1}
                                    max={200}
                                    onChange={(e) => {
                                        player.number = e.target.value;
                                        error.number = FakeData.inArray(e.target.value, jerseyArray)
                                        this.setState({ player, error });
                                    }} />
                            </div>
                            <div className="input-field">
                                <span>County</span>
                                <CountryDropdown classes={(error.origin) ? "normal-input error" : "normal-input"}
                                    value={player.origin}
                                    onChange={(val) => {
                                        player.origin = val;
                                        error.origin = false
                                        this.setState({ player, error });
                                    }} />
                            </div>
                            <button style={{ lineHeight: "30px" }} onClick={this.save.bind(this)}>Add To Squad</button>
                        </div>
                    }
                </div>
            </Modal>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/Squads.jsx